/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2023
 * @format
 * @flow
 */

import axios from "axios";
import Urls from "./mapiUrls";

axios.defaults.timeout = 20000;
axios.defaults.headers.common["Content-Type"] = "application/json";

const mapiAxios = axios.create({
  baseURL: process.env.REACT_APP_MAPI_URL,
});

class MAPI {
  static getCustomizeWaitlist = (brandId, languageId) => {
    let url = Urls.getCustomizeWaitlist;
    url = url.replace('{brandId}', brandId);
    url = url.replace('{languageId}', languageId);
    return mapiAxios.get(url);
  };
}

export default MAPI;
